import React from 'react';
import { VerticalBarChartProps, ThemeConfig, PresetTheme } from '../types';
import { BarChart } from './BarChart';

export interface VerticalBarChartComponentProps extends VerticalBarChartProps {
  /** Preset theme name */
  theme?: PresetTheme;
  /** Custom theme configuration */
  themeConfig?: ThemeConfig;
}

/**
 * VerticalBarChart Component
 * 
 * A classic vertical bar chart component for displaying categorical data.
 * This is a convenience wrapper around BarChart with orientation="vertical".
 * 
 * @example
 * ```tsx
 * <VerticalBarChart
 *   labels={['Q1', 'Q2', 'Q3', 'Q4']}
 *   datasets={[
 *     { label: 'Revenue', data: [30000, 45000, 42000, 55000] },
 *     { label: 'Expenses', data: [20000, 25000, 23000, 28000] }
 *   ]}
 *   borderRadius={4}
 *   theme="corporate"
 * />
 * ```
 */
export const VerticalBarChart: React.FC<VerticalBarChartComponentProps> = (props) => {
  return <BarChart {...props} orientation="vertical" />;
};

export default VerticalBarChart;
